<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" class="MapPnlGrdItem elevation-5 pa-0 my-3" fab small @click="RotateToNorth()">
        <v-icon :style="rotateStyle">mdi-navigation</v-icon>
      </v-btn>
    </template>
    <span>Obnovit severní orientaci mapy</span>
  </v-tooltip>
</template>


<script>
// Funkce pro práci s kompasem, resp. s natočením mapy

//import { VBtn } from "vuetify/lib";
//export default { extends: VBtn };

import { createPoint } from "@luciad/ria/shape/ShapeFactory";
import { OutOfBoundsError } from "@luciad/ria/error/OutOfBoundsError";
import { LocationMode } from "@luciad/ria/transformation/LocationMode";
import { getReference } from "@luciad/ria/reference/ReferenceProvider";
import { ReferenceType } from "@luciad/ria/reference/ReferenceType";
import { createTransformation } from "@luciad/ria/transformation/TransformationFactory";
import { createEllipsoidalGeodesy } from "@luciad/ria/geodesy/GeodesyFactory";
import { PerspectiveCamera } from "@luciad/ria/view/camera/PerspectiveCamera";

const CRS84 = getReference("CRS:84");
const geodesy = createEllipsoidalGeodesy(CRS84);
const OFFSET_DISTANCE = 1000;

const RAD2DEG = 180 / Math.PI;
const clamp = (val, min, max) => {
  return Math.max(min, Math.min(max, val));
};

export default {
  data() {
    return {
      rotateStyle: "",
      rotateX: 0,
      rotateZ: 0,
    };
  },

  props: {
    // Mapa
    Map: Object,
  },
  methods: {
    // Otočení/narovnání mapového výřezu na sever
    RotateToNorth: function () {
      var center;

      try {
        center = this.Map.getViewToMapTransformation(
          LocationMode.CLOSEST_SURFACE
        ).transform(
          createPoint(null, [
            this.Map.viewSize[0] / 2,
            this.Map.viewSize[1] / 2,
          ])
        );
      } catch (e) {
        if (!(e instanceof OutOfBoundsError)) {
          throw e;
        }

        center = this.Map.camera.eyePoint;
      }

      const deltaRotation = -this.getAzimuthAtViewCenter(this.Map);
      this.Map.mapNavigator.rotate({
        animate: true,
        deltaRotation: deltaRotation,
        deltaYaw: deltaRotation,
        center,
      });
    },

    // Vrátí azimut (úhel k severu) ve středu dané mapy.
    getAzimuthAtViewCenter: function () {
      //if the map is unreferenced or 3D, we can just get the camera's rotation
      if (
        this.Map.reference.referenceType === ReferenceType.CARTESIAN ||
        this.Map.reference.referenceType === ReferenceType.GEOCENTRIC
      ) {
        return this.getCameraRotation(this.Map);
      } //In 2D there might not be a general north direction (eg. polar stereographic projection), we calculate the
      //azimuth by getting the angle between the point at the center of the view and another point north of that.

      try {
        const world2llh = createTransformation(this.Map.reference, CRS84);
        const llh2world = createTransformation(CRS84, this.Map.reference);
        const centerViewPoint = createPoint(null, [
          this.Map.viewSize[0] / 2,
          this.Map.viewSize[1] / 2,
        ]);
        const centerllhPoint = world2llh.transform(
          this.Map.viewToMapTransformation.transform(centerViewPoint)
        );
        const higherllhPoint = geodesy.interpolate(
          centerllhPoint,
          OFFSET_DISTANCE,
          0
        );
        const higherViewPoint = this.Map.mapToViewTransformation.transform(
          llh2world.transform(higherllhPoint)
        );
        return (
          Math.atan2(
            centerViewPoint.x - higherViewPoint.x,
            centerViewPoint.y - higherViewPoint.y
          ) * RAD2DEG
        );
      } catch (e) {
        if (e instanceof OutOfBoundsError) {
          return this.getCameraRotation(this.Map);
        } else {
          throw e;
        }
      }
    },

    // Vrátí rotaci (ve 2D) nebo vybočení (ve 3D) kamery mapy.
    getCameraRotation: function () {
      const camera = this.Map.camera;

      if (camera instanceof PerspectiveCamera) {
        return camera.asLookFrom().yaw;
      } else {
        return camera.asLook2D().rotation;
      }
    },

    // Vrátí otočení x a y, které lze použít na ikonu HTML, aby byla zarovnána se severním směrem dané mapy
    calculateCSSRotation: function () {
      var z = -this.getAzimuthAtViewCenter(this.Map);
      var x = 0;
      const camera = this.Map.camera;

      if (camera instanceof PerspectiveCamera) {
        const { pitch: cameraPitch } = camera.asLookFrom(); // most perpendicular pitch is -89 deg

        x = clamp(89 + cameraPitch, 0, 90); // icon rotation is damped to avoid reducing the compass image to a pixel-width line

        x *= 60 / 90;
      }
      this.rotateStyle =
        "transform: rotateX(" + x + "deg) rotateZ(" + z + "deg)";
    },
  },

  mounted() {
    // Vytvoření
    // console.log("Compass")
    // console.log(this.Map)

    this.Map.on("MapChange", this.calculateCSSRotation);

  },
};
</script>

<style></style>